var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { withFlightUI } from '../withFlightUI';
import { DropdownMenuContext, useDropdownMenu } from './DropdownMenu';
export const Item = function Item(_a) {
    var { onSelect, closeOnSelect, children, disabled, index } = _a, rest = __rest(_a, ["onSelect", "closeOnSelect", "children", "disabled", "index"]);
    const { itemRefs } = React.useContext(DropdownMenuContext);
    const { isOpen, setIsOpen } = useDropdownMenu();
    const itemRef = React.createRef();
    itemRefs.current[index] = itemRef;
    const select = () => {
        closeOnSelect && setIsOpen(false);
        typeof onSelect === 'function' &&
            !disabled &&
            onSelect({ isOpen, setIsOpen });
    };
    const handleKeydown = (e) => {
        if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
            e.preventDefault();
            select();
        }
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (itemRefs.current.length - 1 === index)
                return;
            itemRefs.current[index + 1].current.focus();
        }
        if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (index === 0)
                return;
            itemRefs.current[index - 1].current.focus();
        }
    };
    const focusItem = () => itemRef.current && itemRef.current.focus();
    return withFlightUI(children, Object.assign({ as: 'li', ref: itemRef, tabIndex: -1, onClick: select, onKeyDown: handleKeydown, onMouseEnter: focusItem, role: 'menuitem', 'data-flight-dropdown-item': '' }, rest));
};
//# sourceMappingURL=Item.js.map